var _path, _rect, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54868 12.6128C3.06882 14.4144 4.13248 16.266 5.92395 16.7487L14.0336 18.9346C14.1136 18.9561 14.1939 18.9728 14.2739 18.9882C14.058 19.3536 13.7067 19.6388 13.2662 19.7575L5.15652 21.9425C4.26077 22.1839 3.34025 21.6494 3.1002 20.7486L0.0575223 9.33028C-0.182208 8.42965 0.349263 7.50377 1.24475 7.26232L5.26229 6.17969L3.54868 12.6128Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.7586,
    height: 15.1923,
    rx: 2,
    transform: "matrix(0.965559 0.260185 -0.257459 0.966289 8.646 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18016 4.51478C9.30017 4.06436 9.76055 3.79706 10.2084 3.91775L16.6962 5.66599C17.1441 5.78668 17.4099 6.24966 17.2899 6.70009C17.1699 7.15051 16.7095 7.41781 16.2616 7.29712L9.77384 5.54888C9.32595 5.42819 9.06015 4.96521 9.18016 4.51478Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.312 7.7765C8.43201 7.32608 8.89238 7.05878 9.34027 7.17947L15.8281 8.92771C16.276 9.0484 16.5418 9.51138 16.4217 9.9618C16.3017 10.4122 15.8414 10.6795 15.3935 10.5588L8.90567 8.8106C8.45778 8.68991 8.19199 8.22693 8.312 7.7765Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44188 11.0402C7.56189 10.5898 8.02227 10.3224 8.47015 10.4431L10.9031 11.0987C11.351 11.2194 11.6168 11.6824 11.4968 12.1328C11.3767 12.5832 10.9164 12.8506 10.4685 12.7299L8.03555 12.0743C7.58767 11.9536 7.32187 11.4906 7.44188 11.0402Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsDown);
export default __webpack_public_path__ + "static/media/asDown.5c549b3f12aa261f95ce342f4f047e83.svg";
export { ForwardRef as ReactComponent };